import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const isLoadingSelector = (statusKey) => (state) => state.worklistRisks?.[statusKey] === REDUX_ASYNC_STATUSES.LOADING;

export const selectWorklistRisks = (state) => state.worklistRisks?.worklistRisks;
export const selectWorklistRisksLoading = isLoadingSelector('worklistRisksStatus');

export const selectWorklistRiskMessages = (state) => state.worklistRisks?.worklistRiskMessages;
export const selectWorklistRiskMessagesLoading = isLoadingSelector('worklistRiskMessagesStatus');

export const selectWorklistRiskUnreadSinceDate = (state) => state.worklistRisks?.worklistRiskUnreadSinceDate;
export const selectWorklistRiskUnreadSinceDateLoading = isLoadingSelector('worklistRiskUnreadSinceDateStatus');

export const selectDeleteWorklistRiskUnreadSinceLoading = isLoadingSelector('deleteWorklistRiskUnreadSinceStatus');

export const selectCreateWorklistRiskMessageLoading = isLoadingSelector('createWorklistRiskMessageStatus');

export const selectCreateWorklistRiskMessageAndConnectedActionsLoading = isLoadingSelector(
  'createWorklistRiskMessageAndConnectedActionsStatus'
);

export const selectUpdateWorklistRiskMessageLoading = isLoadingSelector('updateWorklistRiskMessageStatus');

export const selectMessageRecipientOrganizations = (state) => state.worklistRisks?.messageRecipientOrganizations;
export const selectMessageRecipientOrganizationsLoading = isLoadingSelector('messageRecipientOrganizationsStatus');

export const selectIsCreateMessageTouched = (state) => state.worklistRisks?.isCreateMessageTouched;
export const selectWorklistRiskNewMessageAttachments = (state) => state.worklistRisks?.newMessageAttachments;
export const selectWorklistRiskNewMessageAttachmentsUploadLoading = (state) =>
  state.worklistRisks?.isNewMessageAttachmentsUploadLoading;

export const selectWorklistRiskReplyRecipientId = (state) => state.worklistRisks?.worklistRiskReplyRecipientId;

export const selectWorklistRiskRecommendations = (state) => state.worklistRisks?.worklistRiskRecommendations;
export const selectWorklistRiskRecommendationsLoading = isLoadingSelector('worklistRiskRecommendationsStatus');

export const selectWorklistRiskReminders = (state) => state.worklistRisks?.worklistRiskReminders;
export const selectWorklistRiskRemindersLoading = isLoadingSelector('worklistRiskRemindersStatus');

export const selectCreateWorklistRiskReminderLoading = isLoadingSelector('createWorklistRiskReminderStatus');

export const selectUpdateWorklistRiskReminderLoading = isLoadingSelector('updateWorklistRiskReminderStatus');

export const selectDeleteWorklistRiskReminderLoading = isLoadingSelector('deleteWorklistRiskReminderStatus');
